import React, { useState } from "react";
import { Container, Modal, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { pageType, DOMAIN_CLINKS } from "constants/app";
import {
  MTCLogoSvgIcn,
  MTCWhiteLogoSvgIcn,
  ClinksLogoSvgIcn,
  SuccessMSvgIcn,
} from "svgIcon/index";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import { getStorageData } from "utils/helper";
import classNames from "classnames";
import { useStyles } from "./styles";
import EmailOrgModalComponent from "./EmailOrgModalComponent";
const HeaderComponent = (props) => {
  const classes = useStyles(props);
  const { className, isPage = pageType.home } = props;
  const domain = getStorageData("domain");
  const [showModal, setShowModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <Navbar
      className={classNames(
        classes.header,
        "headerCommon d-flex align-items-center",
        className
      )}
    >
      <Container fluid="fluid">
        <Navbar.Brand
          className="me-0 position-relative"
          as={Link}
          to="/"
          title={domain === DOMAIN_CLINKS ? "Clinks" : "Make Time Count Today"}
        >
          {domain === DOMAIN_CLINKS ? (
            <>
              <ClinksLogoSvgIcn
                bgColor={
                  isPage === pageType.home
                    ? "rgb(var(--white))"
                    : "rgb(var(--white))"
                }
              />
              <span className="clinksBeta">Beta</span>
            </>
          ) : isPage === pageType.home ? (
            <MTCWhiteLogoSvgIcn />
          ) : (
            <MTCLogoSvgIcn />
          )}
        </Navbar.Brand>
        {isPage !== pageType.details && (
          <Nav className="ms-auto">
            <ButtonComponent
              variant="link"
              onClick={() => {
                setShowModal(true);
              }}
              title="Create Organisation"
              className="p-0"
            >
              Create Organisation
            </ButtonComponent>
          </Nav>
        )}

        {showModal && (
          <EmailOrgModalComponent
            showModal={showModal}
            setShowModal={setShowModal}
            setShowSuccess={setShowSuccess}
          />
        )}

        {showSuccess && (
          <Modal
            show={showSuccess}
            onHide={() => setShowSuccess(false)}
            className="claimsuccess__modal"
          >
            <Modal.Body>
              <Modal.Header closeButton className="p-0 border-0"></Modal.Header>
              <div className="py-3 px-2">
                <div className="d-flex flex-column align-items-center mb-4">
                  <div className="mmail__icn mismm__icn rounded-pill d-flex align-items-center justify-content-center mb-4">
                    <SuccessMSvgIcn />
                  </div>
                  <h5 className="mb-2 fw-bold text-dark text-center">
                    Email Sent Successfully!
                  </h5>
                  <p className="mb-0 fw-normal text-center">
                    A verification link has been sent to your email. Check your
                    inbox or spam folder, and try again after a few minutes if
                    you don't see it.
                  </p>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                  <ButtonComponent
                    variant="dark"
                    onClick={() => setShowSuccess(false)}
                    title="Got it"
                    style={{ maxWidth: "150px" }}
                    className="w-100"
                  >
                    Got it
                  </ButtonComponent>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </Container>
    </Navbar>
  );
};

export default HeaderComponent;
